import classes from './mapDrawerContent.module.css';

interface Props {
  title: string;
}

const SectionHeading = ({ title }: Props) => {
  return (
    <div className={classes.sectionHeadingContainer}>
      <div>{title}</div>
    </div>
  );
};

export default SectionHeading;
